import SpriteSymbol from "../../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "add_user",
  "use": "add_user-usage",
  "viewBox": "0 0 15 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 16\" id=\"add_user\"><path d=\"M11.5 5C11.5 2.519 9.481.5 7 .5A4.505 4.505 0 002.5 5c0 1.217.49 2.32 1.278 3.13C1.902 8.584.5 10.266.5 12.279V15.5H2v-3.221A2.779 2.779 0 014.779 9.5H7c2.481 0 4.5-2.019 4.5-4.5zM7 8a3 3 0 110-6 3 3 0 010 6zm5.75 4.25V10h-1.5v2.25H9v1.5h2.25V16h1.5v-2.25H15v-1.5h-2.25z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol